module.exports = __webpack_public_path__ + "42624bfb74f9f6e528e2929e5383106c.png";